import React from 'react';

const Modal = ({show, item, onClose}) => {
    if(!show){
        return null;
    }
    let thumbnail = item.volumeInfo.imageLinks && item.volumeInfo.imageLinks.smallThumbnail;
    return (
        <div>
            <div className='overlay'>
                <div className='overlay-inner'>
                    <button className="close" onClick={onClose}><i className="material-icons">clear</i></button>
                    <div className='inner-box'>
                        <img src={thumbnail} />
                        <div className="info">
                            <h1>{item.volumeInfo.title.slice(0, 14)}...</h1>
                            <h3>{item.volumeInfo.authors}</h3>
                            <h4>{item.volumeInfo.publisher} <span>{item.volumeInfo.publishedDate}</span></h4>
                            <a href={item.volumeInfo.previewLink}><button className='btn btn-primary'>more</button> </a>
                        </div>

                    </div>
                    <div className="discription">
                        <p>{item.volumeInfo.description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;